import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, ViewChild, OnInit, inject } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { LoaderComponent } from "../../../general/components/loader/loader.component";
import { EmailLog } from "../../models/email-log";
import { AdminService } from "../../services/admin.service";
import { tap } from "rxjs";
import { DialogService } from "../../../services/dialog.service";
import { HapticsService } from "../../../general/services/haptics.service";
import { TemplateSendComponent } from "../template-send/template-send";
import { EmailTemplate } from "../../models/admin-template-email-request";


@Component({
  selector: 'app-email-logs',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatSortModule,
    LoaderComponent
],
  templateUrl: './email-logs.html',
  styleUrl: './email-logs.scss',
})
export class EmailLogsComponent implements OnInit {
    private admin = inject(AdminService);
    private dialogService = inject(DialogService);
    private haptics = inject(HapticsService);
    private cdr = inject(ChangeDetectorRef);

    isLoading = false;
  displayedColumns: string[] = ['templateId', 'senderName', 'sendToName', 'sendToEmail', 'status', 'isOpened', 'clickCount', 'updatedAt', 'createdAt'];
  dataSource = new MatTableDataSource<EmailLog>();
  templates: EmailTemplate[] = [
          { id: '0', name: 'Stop paying booking fees', description: 'Brief message to reach out to potential client', icon: 'block' },
          { id: '1', name: 'Save $X per property annually', description: 'Sent after a successful reservation', icon: 'percent_discount' },
          { id: '2', name: 'Quick Thought', description: 'Marketing blast for properties', icon: 'campaign' },
          { id: '3', name: 'Helping managers reduce platform dependency', description: 'Reduces reliance on expensive third-party platforms', icon: 'pinch_zoom_in'},
          { id: '4', name: 'Respond to Sales Application', description: 'Quick response with instructions for sales applicants', icon: 'reply'}
      ];
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.dataSource.paginator = mp;
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    if (ms) {
      ms.active = 'createdAt';
      ms.direction = 'desc';
      this.dataSource.sort = ms;
    }
  }

  ngOnInit() {
    this.loadEmailLogs();
  }

  loadEmailLogs() {
    this.admin.getEmailLogs().pipe(tap((result: EmailLog[]) => {
        this.dataSource.data = result;
        this.cdr.detectChanges();
    })).subscribe();
  }

  createEmail() {
    this.haptics.click();
    const ref = this.dialogService.open(TemplateSendComponent, {

    });
    ref.afterClosed().subscribe(result => {
        if (result) {
            console.log('template send result', result);
        }
    });
    ref.componentInstance.success.subscribe((data) => {
      this.loadEmailLogs();
    });
    ref.componentInstance.cancel.subscribe(() => {
      ref.close();
    });
  }
}